import React from 'react'

function Search() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <g>
                <path
                    fill="currentColor"
                    d="M15.607 13.727l-3.094-3.06a6.833 6.833 0 10-5.68 3.04 6.76 6.76 0 003.793-1.16l3.1 3.1a1.333 1.333 0 001.88 0 1.333 1.333 0 000-1.92zM6.833 2A4.833 4.833 0 112 6.84 4.84 4.84 0 016.833 2z"
                ></path>
            </g>
        </svg>
    )
}

export default Search
